
<template>
  <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/about">About</router-link> | 
    <router-link to="/checkconnection">checkconnection</router-link> |
    <router-link to="/experience">experience</router-link>

  </nav> -->
  <!-- <select
    class="form-select"
    id="chooseLanguage"
    onchange="location = this.value;"
  >
    <option value="?lang=vi">
      {{ $t("message.vietnamese", {}, { locale: lang }) }}
    </option>
    <option value="?lang=en">
      {{ $t("message.english", {}, { locale: lang }) }}
    </option>
  </select> -->

  <router-view />

</template>

<script>
import $ from "jquery";
import { i18n } from "./app-i18n";

export default {
  data() {
    return {
      // lang: "en",
    };
  },
 
 
  mounted() {
    // i18n.locale= sessionStorage.getItem("lang")|| this.lang;
    // sessionStorage.setItem("lang",this.lang)
    // setInterval(() => {
    //   if (this.$route.query.lang == "vi") {
    //     this.lang = "vi";
    //     sessionStorage.setItem("lang",this.lang)
    //     $("#chooseLanguage").val("?lang=vi");
    //   } else if(this.$route.query.lang == "en") {
    //     this.lang = "en";
    //     sessionStorage.setItem("lang",this.lang)
    //     $("#chooseLanguage").val("?lang=en");
    //   } else if(sessionStorage.getItem("lang") == 'vi'){
    //     this.lang = "vi";
    //     $("#chooseLanguage").val("?lang=vi");
    //   } else {
    //     this.lang = "en";
    //     sessionStorage.setItem("lang",this.lang)
    //     $("#chooseLanguage").val("?lang=en");
    //   }
    // });
  }
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#chooseLanguage {
  width: auto;
  top: 30px;
  position: absolute;
  right: 0;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
